import axios from "axios";
import { BASE_URL } from "../config";

const getAuthHeaders = () => {
  const token =
    localStorage.getItem("authentication/token") ||
    localStorage.getItem("auth_token") ||
    localStorage.getItem("token") ||
    "";

  return token
    ? {
        Authorization: `Bearer ${token}`,
      }
    : {};
};

const API_PREFIX = `${BASE_URL}/admin/dynamic-table-update`;

// Tables
export const getAvailableTables = () =>
  axios.get(`${API_PREFIX}/tables`, { headers: getAuthHeaders() });

// Columns for a table
export const getTableColumns = (tableName) =>
  axios.get(`${API_PREFIX}/tables/${encodeURIComponent(tableName)}/columns`, {
    headers: getAuthHeaders(),
  });

// Preview affected rows
export const previewAffectedRows = (payload) =>
  axios.post(`${API_PREFIX}/preview`, payload, { headers: getAuthHeaders() });

// Execute update
export const executeTableUpdate = (payload) =>
  axios.post(`${API_PREFIX}/execute`, payload, { headers: getAuthHeaders() });

// Blocked tables
export const getBlockedTables = () =>
  axios.get(`${API_PREFIX}/blocked-tables`, { headers: getAuthHeaders() });

export const addBlockedTable = (payload) =>
  axios.post(`${API_PREFIX}/blocked-tables`, payload, {
    headers: getAuthHeaders(),
  });

export const removeBlockedTable = (id) =>
  axios.delete(`${API_PREFIX}/blocked-tables/${id}`, {
    headers: getAuthHeaders(),
  });

// Audit logs
export const getAuditLogs = (params) =>
  axios.get(`${API_PREFIX}/audit-logs`, {
    params,
    headers: getAuthHeaders(),
  });

// Revert an audit log entry
export const revertAuditLog = (auditLogId) =>
  axios.post(`${API_PREFIX}/audit-logs/${auditLogId}/revert`, {}, {
    headers: getAuthHeaders(),
  });
